import classes from "./MessagingContentCard.module.css";
import { Divider } from "@mui/material";

const MessagingDetailsContentCard = (props) => {
  // renders the provided detailsData or contentCard
  return (
    <div className={classes.contentCardContainer}>
      {props?.detailsData ? props?.detailsData?.map((entry, index) => {
        return (
          <div key={index}>
            <Divider />
            <div className={classes.messagingContainer}>
              <div className={classes.messagingItem}>
                <div className={classes.total}>{entry.title}</div>
                <div className={classes.total}>{entry.value}</div>
              </div>
            </div>
          </div>
        )
      }) : props?.contentCard &&
        <>
          {props.contentCard}
        </>
      }
    </div>
  );
};

export default MessagingDetailsContentCard;
